import Icon from "@mui/material/Icon";

// Pages
//import Pricing from "layouts/pages/landing-pages/Pricing";
import Home from "pages/Home";
import AboutUs from "pages/AboutUs";
import Booking from "pages/Booking";
import Employee from "pages/Employee";
import Employer from "pages/Employer";
import ContactUs from "pages/ContactUs";
import TermsAndConditions from "pages/Terms";
import { PrivacyPolicyPage } from "pages/Privacy";
import { DisclaimerPage } from "pages/Disclaimer";

const routes = [
  {
    name: "HOME",
    icon: <Icon>home</Icon>,
    route: "/",
    component: <Home />,
  },
  {
    name: "ABOUT",
    icon: <Icon>info</Icon>,
    route: "/about",
    component: <AboutUs />,
  },
  {
    name: "CONTACT",
    icon: <Icon>contact_mail</Icon>,
    route: "/contact",
    component: <ContactUs />,
  },
  {
    route: "/booking",
    component: <Booking />,
  },
  {
    route: "/employer",
    component: <Employer />,
  },
  {
    route: "/employee",
    component: <Employee />,
  },
  {
    route: "/terms-condtions",
    component: <TermsAndConditions />,
  },
  {
    route: "/privacy-policy",
    component: <PrivacyPolicyPage />,
  },
  {
    route: "/disclaimer",
    component: <DisclaimerPage />,
  },
];

export default routes;
